import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import StyledZeroState from './StyledZeroState';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SearchNoThreadFocused = () => {
  return /*#__PURE__*/_jsxs(StyledZeroState, {
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "no-conversations",
      width: "200px"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      color: "icon-core-subtle",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.selectResults"
      })
    })]
  });
};
SearchNoThreadFocused.displayName = 'NoFocusedThread';
export default SearchNoThreadFocused;